import { setCookie as _, getCookie as l } from "./cookies.js";
const m = [
  "btag",
  "fid",
  "adfuid",
  "_adfcd",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "affiliate_id"
], g = {
  adfcookieid: "adfuid",
  adfcd: "_adfcd"
}, P = 30, w = {
  btag: "btag",
  fid: "fid",
  adfuid: "adfuid",
  _adfcd: "_adfcd",
  utm_source: "utmSource",
  utm_medium: "utmMedium",
  utm_campaign: "utmCampaign",
  utm_term: "utmTerm",
  utm_content: "utmContent",
  affiliate_id: "affiliateId"
};
function M(a) {
  return Object.entries(a).reduce(
    (n, [e, t]) => {
      const o = e.toLowerCase(), r = w[o] || e;
      return n[r] = t, n;
    },
    {}
  );
}
function d(a, n, e) {
  const t = e == null ? void 0 : e.find((o) => o.key === n);
  if (t && t.type === "regex") {
    const o = new RegExp(t.value);
    return a && o.test(a) ? a : t.defaultValue;
  }
  if (t && t.type !== "regex")
    throw new Error(`Invalid validator type: ${t.type}`);
  return a;
}
function C(a, n) {
  Object.entries(a).forEach(([e, t]) => {
    const o = e.toLowerCase(), r = d(t, o, n) ?? t;
    _(o, r, P);
  });
}
function h(a) {
  return m.reduce(
    (n, e) => {
      const t = l(e), o = d(t, e, a) ?? t;
      return o && (n[e] = o), n;
    },
    {}
  );
}
function y(a) {
  const n = new URLSearchParams(window.location.search), e = {}, t = [];
  for (const [o, r] of n.entries()) {
    const i = o.toLowerCase(), s = g[i], u = m.find(
      (f) => f.toLowerCase() === i
    ), c = s ?? u;
    c && r && (e[c] = r, t.push(o));
  }
  Object.keys(e).length > 0 && (C(e, a), p(t));
}
function p(a) {
  const n = new URL(window.location.href);
  a.forEach((e) => n.searchParams.delete(e)), window.history.replaceState({}, document.title, n.toString());
}
export {
  m as MARKETING_SOURCE_PARAMS,
  M as convertMarketingParamsToCamelCase,
  h as getMarketingCookies,
  d as getValidatedMarketingParam,
  y as storeMarketingParams,
  C as storeMarketingParamsInCookies
};
